/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/commonClasses/commonContextBase.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    import StorageFile = Meevo.Model.IStorageFile;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    'use strict';

    export class WalkinManagerSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Plugins.WalkinManagerSettings.IDataServiceSettings,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Components.Tracking.ITrackingService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            // initialize endpoint
            this.baseEndpoint = appSettings.API_ENDPOINTS.walkInSettings;
            // initialize templatepaths
            this.sectionTemplatePath = 'app/plugins/walkinManagerSettings/sectionViews/';

            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsCommonDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: this.baseEndpoint,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                sectionSecurityKey: ''
            };

            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {

                this.sections.push(new MainSection(_.extend({}, baseSectionProps, {
                    displayNameContentKey: 'SECTION_MAIN_SETTINGS',
                    template: 'main.html',
                    isPrimarySection: true,
                    noun: Model.NounEnum.WalkInManagerSettingMainSettings,
                    identityService: this.identityService,
                    modalService: this.modalService,
                    sectionEndpoint: '?includeMetadata=true',
                    sectionSecurityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new NotificationsSection(_.extend({}, baseSectionProps, {
                    sectionId: 3,
                    displayNameContentKey: 'SECTION_NOTIFICATIONS',
                    template: 'notifications.html',
                    noun: Model.NounEnum.WalkInManagerSettingNotifications,
                    sectionSecurityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_WALKINHOURS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new WalkInHoursSection(_.extend({}, baseSectionProps, {
                    sectionId: 4,
                    displayNameContentKey: 'SECTION_WALKIN_HOURS',
                    template: 'walkinHours.html',
                    noun: Model.NounEnum.WalkInManagerSettingWalkInHours,
                    sectionSecurityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_WALKINHOURS + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new WalkInEmployeeSection(_.extend({}, baseSectionProps, {
                    sectionId: 5,
                    displayNameContentKey: 'HEADER_EMPLOYEE',
                    template: 'employee.html',
                    noun: Model.NounEnum.WalkInManagerSettingEmployees,
                    sectionSecurityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    identityService: this.identityService
                })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new WalkInServicesSection(_.extend({}, baseSectionProps, {
                    sectionId: 6,
                    displayNameContentKey: 'SERVICES',
                    template: 'services.html',
                    noun: Model.NounEnum.WalkInManagerSettingServices,
                    sectionSecurityKey: this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    identityService: this.identityService
                })));
            }

            this.activate();
        }

        /**
         * Override edit to check if services have been selected
         */
        edit(): void {
            if (this.selectedSection.isPrimarySection && !this.isApplicationModeCO()) {
                this.dataService.getCount('service', {criteria: {eligibleForWalkinManager: true}})
                    .then(response => {
                        if (response === 0) {
                            this.modalService.alert('MESSAGE_WALKIN_SETTINGS_SERVICES_REQUIRED',
                                Meevo.Components.Modal.ModalTranslationModes.Translate);
                        } else {
                            super.edit();
                        }
                    });
            } else {
                super.edit();
            }
        }

        /**
         * Saves the item currently being edited/added.
         */
        save(): angular.IPromise<any> {
            if ([5, 6].indexOf(this.selectedSection.sectionId) !== -1 && this.canSave) {
                return super.customSave();
            }

            return super.save();
        }

        /**
         * Selects the specified section of the maintance form and activates it.
         * @param {Meevo.Components.CommonClasses.ICommonSection} section
         * @returns {}
         */
        selectSection(section: Meevo.Components.CommonClasses.ICommonSection): void {
            if (this.selectedSection && this.selectedSection != section && this.navigationBlocked) {
                this.modalService.alert('MESSAGE_PENDING_CHANGES');
            } else {
                // build security attributes
                switch (section.sectionId) {
                    case 0:
                        this.buildCrudSecurityKeysBase(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_MAIN, true, false);
                        break;
                    case 3:
                        this.buildCrudSecurityKeysBase(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_NOTIFICATIONS);
                        break;
                    default:
                        this.buildCrudSecurityKeysBase(this.securityKeys.APPOINTMENTS_WALKINMANAGERSETTINGS_TAB_WALKINHOURS);
                        break;
                }
                super.selectSection(section);

                /*this.loadingInProgress = true;

                this.dataService.getSection(this.baseEndpoint, this.selectedSection.sectionEndpoint).then((data: any) => {
                    this.selectedSection.model = data;
                    this.selectedSection.activate();

                    if (this.selectedSection.isPrimarySection) {
                        this.initializeHeader(data);
                    }

                }).finally(() => { this.loadingInProgress = false }); */
            }
        }

        initializeHeader(model: any): void {
            let businfoModel = <Meevo.Model.BusinessInfo>model;
            this.headerContent = businfoModel.storeName;
        }

        /**
         * Gets or set the holidayType value
         */
        private _holidayTypeDetail: Model.IntDetail;
        get holidayTypeDetail(): Model.IntDetail {
            return this._holidayTypeDetail;
        }

        get securityAccessEnum(): any {
            return SecurityAccessEnum;
        }

        set holidayTypeDetail(value: Model.IntDetail) {
            this._holidayTypeDetail = value;
            if (this._holidayTypeDetail === null || this._holidayTypeDetail === undefined)
                return;
            let request = {holidayTypeId: this._holidayTypeDetail.id};
            this.dataService.getListPaged('/Tenant/HolidayTypeHolidays', request)
                .then(response => {
                    this.holidayTypeHolidays = response;
                });
        }

        valueInArray(stuff) {
            let holidayModel: Model.HolidayLocal[] = this.selectedSection.model.holidaySettings.holidays;
            return _.some(holidayModel, function (aHoliday) {
                return aHoliday.displayName == stuff.displayName;
            });
        }

        bindWalkinImage(imageData: StorageFile, url: any): any {
            if (imageData) {
                url = this.searchFile(imageData, 'Source', url);
            }
            return url;
        }
    }
}
